import { ApiEndPoint } from "../../../../../network/api_end_point";
import { fileDownloader } from "../../../../../network/network_helper";
import StringUtils from "../../../../../utils/string_utils";

const apiEndPoint = new ApiEndPoint();

const downloadTaskApiCall = async (taskId) => {
    const url = `${apiEndPoint.hawkBaseUrl}${apiEndPoint.downloadTaskApiUrl}/${taskId}/pdf?source=FM_DASHBOARD`;

    const success = await fileDownloader({
        url,
        fileName: `${StringUtils.task}_${taskId}`,
        fileType: "pdf",
    });

    if (!success) throw new Error(StringUtils.downloadFailed);

    return { message: StringUtils.downloadSuccess };
};

export default downloadTaskApiCall;
